var swiper = new Swiper(".block_collection-products-banner-slider", {
  slidesPerView: 1.5,
  spaceBetween: 16,
  navigation: {
    nextEl: ".collection-hero .block_slider-right-arrow",
    prevEl: ".collection-hero .block_slider-left-arrow",
  },
  mousewheel: {
    forceToAxis: true,
  },
    breakpoints: {
    270: {
      slidesPerView: 2.2 
    },
    320: {
      slidesPerView: 2.7  
    },
    380: {
      slidesPerView: 3.2  
    },
     549: {
      slidesPerView: 3.4
    },
    640: {
      slidesPerView: 5
    }, 
     749: {
      slidesPerView: 3
    }, 
    989: {
      slidesPerView: 6
    },
    1440: {
      slidesPerView: 7
    }
  }
});